import React, { useEffect } from "react";
import { FrameInterface } from "../../../../store/mine_craft/framesSlice";

import {Button, Form, Input, InputNumber, Radio} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import {DollarOutlined} from "@ant-design/icons";

interface propsInterface {
  params?: FrameInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='image' label='Image' preview={params?.image_url} />
      </div>

      <Form.Item label="Frame type" name='frame_type'>
        <Radio.Group>
          <Radio value='static'>Static</Radio>
          <Radio value='animated'>Animated</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name='coins' label='Coins'>
        <InputNumber
          min={0}
          step={5}
          placeholder='0'
          prefix={<DollarOutlined />}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
